import{a as e}from"./chunk-IBNOB7HH.js";import{a as c}from"./chunk-OUEPJKUR.js";import{e as t}from"./chunk-LHCY2HW6.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-JX5SSSLF.js.map
